import React from 'react';
import { withRouter } from "react-router-dom";
import ResourceSubHeading from "./ResourceSubHeading";
import ResourceSubDescription from "./ResourceSubDescription";

const ResourceSubTile = ({
    headingAs,
    className,
    customLink,
    content,
    count,
    disabled,
    description,
    heading,
    linkHeading = true,
    logName,
    url
}) => {

    const subTileClasses = [
        `col-12 resource-sub-tile-container`,
        `${className ? className : ''}`,
    ].join(' ');

    return (<div className={subTileClasses}>
        <ResourceSubHeading
            as={headingAs}
            customLink={customLink}
            heading={heading}
            linkHeading={linkHeading}
            logName={logName}
            count={count}
            disabled={disabled}
            url={url}
        />
        {content
            ? content
            : <ResourceSubDescription
                description={description}
                disabled={disabled}
            />
        }
        
    </div>);
}

export default withRouter(ResourceSubTile);
